/**
 * Collection Custom Grid - JavaScript
 * Handles add to cart functionality and user interactions
 */

document.addEventListener('DOMContentLoaded', function() {
  // Handle add to cart form submissions
  const addToCartForms = document.querySelectorAll('.add-to-cart-form');
  
  addToCartForms.forEach(form => {
    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      
      const formData = new FormData(form);
      const button = form.querySelector('.add-to-cart-btn');
      const originalHTML = button.innerHTML;
      
      // Show loading state
      button.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-dasharray="31.416" stroke-dashoffset="31.416"><animate attributeName="stroke-dasharray" dur="2s" values="0 31.416;15.708 15.708;0 31.416;0 31.416" repeatCount="indefinite"/><animate attributeName="stroke-dashoffset" dur="2s" values="0;-15.708;-31.416;-31.416" repeatCount="indefinite"/></circle></svg>';
      button.disabled = true;
      
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        
        if (response.ok) {
          const data = await response.json();
          
          // Show success feedback
          button.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          button.style.background = '#4caf50';
          button.style.color = '#fff';
          
          // Update cart count if cart drawer/count element exists
          updateCartCount();
          
          // Reset button after 1.5 seconds
          setTimeout(() => {
            button.innerHTML = originalHTML;
            button.style.background = '';
            button.style.color = '';
            button.disabled = false;
          }, 1500);
        } else {
          throw new Error('Failed to add to cart');
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
        
        // Show error feedback
        button.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
        button.style.background = '#f44336';
        button.style.color = '#fff';
        
        // Reset button after 2 seconds
        setTimeout(() => {
          button.innerHTML = originalHTML;
          button.style.background = '';
          button.style.color = '';
          button.disabled = false;
        }, 2000);
      }
    });
  });
});

/**
 * Update cart count in the header/navigation
 * This function looks for common cart count selectors
 */
function updateCartCount() {
  // Try to fetch updated cart and update count
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartCount = cart.item_count;
      
      // Update various possible cart count elements
      const cartCountSelectors = [
        '.cart-count',
        '[data-cart-count]',
        '.cart-link .count',
        '#cart-count'
      ];
      
      cartCountSelectors.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(el => {
          el.textContent = cartCount;
          el.style.display = cartCount > 0 ? '' : 'none';
        });
      });
      
      // Trigger custom event for theme compatibility
      document.dispatchEvent(new CustomEvent('cart:updated', { 
        detail: { cart: cart, count: cartCount } 
      }));
    })
    .catch(error => {
      console.error('Error updating cart count:', error);
    });
}

